"use client";

import { getCookie } from "cookies-next";
import { ChevronDown, LogOutIcon, Settings, User } from "lucide-react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { COOKIE_CONFIG } from "@/config";
import { useProfileDropdown } from "@/components/hooks/profileDropdown/useProfileDropDown.hook";

const ProfileDropdown = () => {
  const { isMounted, profileData, logout, changeRoute } = useProfileDropdown();

  if (!isMounted) {
    return null; // or a loading placeholder
  }

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className="items-center gap-3 focus:outline-none flex w-full">
        <Avatar className="w-[32px] h-[32px]">
          <AvatarImage src={profileData?.image?.url || ""} />
          <AvatarFallback>
            <User width={15} className="" />
          </AvatarFallback>
        </Avatar>

        <div className="min-w-0">
          <p className="text-sm truncate text-start text-white">
            {profileData?.name ? profileData?.name : "User"}
          </p>
        </div>

        <ChevronDown className="ml-auto w-4 h-4 shrink-0 text-white" />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        alignOffset={0}
        sideOffset={5}
        className="flex flex-col px-0 gap-2 w-[256px]"
        align="end"
      >
        <DropdownMenuGroup>
          <div className="flex gap-4 items-start p-4">
            <Avatar className="w-[40px] h-[40px]">
              <AvatarImage src={profileData?.image?.url || ""} />
              <AvatarFallback className="">
                {profileData?.name
                  ? profileData?.name
                    .split(" ")
                    .map((item: string) => item[0])
                    .join("")
                  : "User"}
              </AvatarFallback>
            </Avatar>

            <div className="w-full min-w-0">
              <p className="text-sm font-bold text-zinc-800">
                {profileData?.name}
              </p>
              <p className="text-sm break-words text-zinc-500">
                {profileData?.email}
              </p>
            </div>
          </div>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />

        <DropdownMenuGroup className="px-3">
          <DropdownMenuItem
            onClick={() => changeRoute("/profile")}
            className="flex items-center gap-2 px-3 py-2.5 cursor-pointer "
          >
            <User size={16} /> My account
          </DropdownMenuItem>

        </DropdownMenuGroup>

        <DropdownMenuSeparator />
        <DropdownMenuGroup className="px-3 pb-3">
          <DropdownMenuItem
            className="flex items-center gap-2 px-3 py-2.5 cursor-pointer text-red-500 hover:!text-red-500"
            onClick={() => logout()}
          >
            <LogOutIcon size={16} />
            Logout
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ProfileDropdown;
